module.exports = __webpack_public_path__ + "static/media/burn-poster.a759257b.png";